<div class="page-header">
    <h6 class="page-titles" style="cursor:context-menu;">
        <span class="page-title-icons bg-gradient-primary text-white mr-2">
            <i class="mdi mdi-book-open-page-variant menu-icon"></i>
        </span> กฎหมายและระเบียบที่เกี่ยวข้อง
    </h6>
</div>
<div>
    <ul class="nav nav-pills nav-pills-primary " id="v-pills-tab" role="tablist" aria-orientation="vertical">
        <li class="nav-item" (click)="displayPdf = false">
            <a class="nav-link active" id="v-pills-act-tab" data-toggle="pill" href="#v-pills-act" role="tab"
                aria-selected="true">
                <i class="mdi mdi-bookmark-outline"></i> พระราชบัญญัติ และกฎกระทรวง </a>
        </li>
        <li class="nav-item" (click)="displayPdf = false">
            <a class="nav-link" id="v-pills-law-tab" data-toggle="pill" href="#v-pills-law" role="tab"
                aria-selected="false">
                <i class="mdi mdi-bookmark-outline"></i> กฎหมายอื่น ๆ ที่เกี่ยวข้อง </a>
        </li>
        <li class="nav-item" (click)="displayPdf = false">
            <a class="nav-link" id="v-pills-announce-tab" data-toggle="pill" href="#v-pills-announce" role="tab"
                aria-selected="false">
                <i class="mdi mdi-bookmark-outline"></i> ประกาศ คำสั่งคณะกรรมการ </a>
        </li>
    </ul>

    <div class="tab-content" id="v-pills-tabContent">
        <div class="tab-pane fade show active" id="v-pills-act" role="tabpanel" style="min-height: 60vh;">
            <div *ngIf="!displayPdf">
                <div class="table-responsive" style="cursor:context-menu;">
                    <table class="table table-striped">
                        <colgroup>
                            <col style="width: 5%; text-align: center;">
                            <col style="width: 80%;">
                        </colgroup>
                        <tbody>
                            <tr *ngFor="let file of data_act| paginate : {
            itemsPerPage: tableSize_act,
            currentPage: page_act,
            totalItems: count_act
          };" style="cursor: pointer;">
                                <td><i class="mdi mdi-file-document"></i></td>
                                <td>{{file.pdf_name}}</td>
                                <td class="text-center">
                                    <!-- <button type="button" class="btn btn-inverse-danger btn-icon btn-sm"
                                        (click)="onClickView(file.pdf_file, file.pdf_name)">
                                        <i class="mdi mdi-eye"></i>
                                    </button>
                                    <button type="button" class="btn btn-inverse-primary btn-icon btn-sm"
                                        style="margin-left: 10px;"
                                        (click)="onClickDownload(file.pdf_file, file.pdf_name)">
                                        <i class="mdi mdi-download"></i>
                                    </button> -->
                                    <a href="https://ogc.mapedia.co.th/api/v1/lrfund/m_file/{{ file.pdf_file }}" type="button" class="btn btn-inverse-primary btn-sm" target="_blank" ><i class="mdi mdi-file-document" style="font-size: 12px;"></i></a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style="position: absolute; left: 0; bottom: 30px; width: 100%;">
                    <pagination-controls *ngIf="data_act.length!=0" class="my-pagination" previousLabel="ก่อนหน้า"
                        nextLabel="ถัดไป" (pageChange)="onTableAct($event)" style="text-align: center;">
                    </pagination-controls>
                </div>
            </div>
            <div *ngIf="displayPdf">
                <div class="card-body">
                    <div class="row">
                        <div class="col-9 text-left" style="cursor:context-menu;">
                            {{pdfName}}</div>
                        <div class="col-3 text-right"><button type="button" class="btn btn-outline-primary"
                                (click)="onClickClose()">ย้อนกลับ</button></div>
                    </div>
                    <pdf-viewer [original-size]="false" [src]="pdfView" [render-text]="true"
                        style="display: block;"></pdf-viewer>
                </div>
            </div>
        </div>
        <div class="tab-pane fade" id="v-pills-law" role="tabpanel" style="min-height: 60vh;">
            <div *ngIf="!displayPdf">
                <div class="table-responsive" style="cursor:context-menu;">
                    <table class="table table-striped">
                        <colgroup>
                            <col style="width: 5%; text-align: center;">
                            <col style="width: 80%;">
                        </colgroup>
                        <tbody>
                            <tr *ngFor="let file of data_law| paginate : {
            itemsPerPage: tableSize_law,
            currentPage: page_law,
            totalItems: count_law
          };" style="cursor: pointer;">
                                <td><i class="mdi mdi-file-document"></i></td>
                                <td>{{file.pdf_name}}</td>
                                <td class="text-center">
                                    <!-- <button type="button" class="btn btn-inverse-danger btn-icon btn-sm"
                                        (click)="onClickView(file.pdf_file, file.pdf_name)">
                                        <i class="mdi mdi-eye"></i>
                                    </button>
                                    <button type="button" class="btn btn-inverse-primary btn-icon btn-sm"
                                        style="margin-left: 10px;"
                                        (click)="onClickDownload(file.pdf_file, file.pdf_name)">
                                        <i class="mdi mdi-download"></i>
                                    </button> -->
                                    <a href="https://ogc.mapedia.co.th/api/v1/lrfund/m_file/{{ file.pdf_file }}" type="button" class="btn btn-inverse-primary btn-sm" target="_blank" ><i class="mdi mdi-file-document" style="font-size: 12px;"></i></a>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style="position: absolute; left: 0; bottom: 30px; width: 100%;">
                    <pagination-controls class="my-pagination" previousLabel="ก่อนหน้า" *ngIf="data_law.length!=0"
                        nextLabel="ถัดไป" (pageChange)="onTableLaw($event)" style="text-align: center;">
                    </pagination-controls>
                </div>
            </div>
            <div *ngIf="displayPdf">
                <div class="card-body">
                    <div class="row">
                        <div class="col-9 text-left" style="cursor:context-menu;">
                            {{pdfName}}</div>
                        <div class="col-3 text-right"><button type="button" class="btn btn-outline-primary"
                                (click)="onClickClose()">ย้อนกลับ</button></div>
                    </div>
                    <pdf-viewer [original-size]="false" [src]="pdfView" [render-text]="true"
                        style="display: block;"></pdf-viewer>
                </div>
            </div>
        </div>
        <div class="tab-pane fade" id="v-pills-announce" role="tabpanel" style="min-height: 60vh;">
            <div *ngIf="!displayPdf">
                <div class="table-responsive" style="cursor:context-menu;">
                    <table class="table table-striped">
                        <colgroup>
                            <col style="width: 5%; text-align: center;">
                            <col style="width: 80%;">
                        </colgroup>
                        <tbody>
                            <tr *ngFor="let file of data_announce| paginate : {
            itemsPerPage: tableSize_ann,
            currentPage: page_ann,
            totalItems: count_ann
          };" style="cursor: pointer;">
                                <td><i class="mdi mdi-file-document"></i></td>
                                <td>{{file.pdf_name}}</td>
                                <td class="text-center">
                                    <!-- <button type="button" class="btn btn-inverse-danger btn-icon btn-sm"
                                        (click)="onClickView(file.pdf_file, file.pdf_name)">
                                        <i class="mdi mdi-eye"></i>
                                    </button>
                                    <button type="button" class="btn btn-inverse-primary btn-icon btn-sm"
                                        style="margin-left: 10px;"
                                        (click)="onClickDownload(file.pdf_file, file.pdf_name)">
                                        <i class="mdi mdi-download"></i>
                                    </button> -->
                                    <a href="https://ogc.mapedia.co.th/api/v1/lrfund/m_file/{{ file.pdf_file }}" type="button" class="btn btn-inverse-primary btn-sm" target="_blank" ><i class="mdi mdi-file-document" style="font-size: 12px;"></i></a>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style="position: absolute; left: 0; bottom: 30px; width: 100%;">
                    <pagination-controls class="my-pagination" previousLabel="ก่อนหน้า"
                        *ngIf="data_announce.length!=0" nextLabel="ถัดไป" (pageChange)="onTableAnn($event)"
                        style="text-align: center;">
                    </pagination-controls>
                </div>
            </div>
            <div *ngIf="displayPdf">
                <div class="card-body">
                    <div class="row">
                        <div class="col-9 text-left" style="cursor:context-menu;">
                            {{pdfName}}</div>
                        <div class="col-3 text-right"><button type="button" class="btn btn-outline-primary"
                                (click)="onClickClose()">ย้อนกลับ</button></div>
                    </div>
                    <pdf-viewer [original-size]="false" [src]="pdfView" [render-text]="true"
                        style="display: block;"></pdf-viewer>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- <app-header-landing></app-header-landing>
<div style="width: 100%;">
    <div class="content-wrapper">
        <div class="page-header">
            <h3 class="page-titles" style="cursor:context-menu;">
                <span class="page-title-icons bg-gradient-primary text-white mr-2">
                    <i class="mdi mdi-book-open-page-variant menu-icon"></i>
                </span> กฎหมายและระเบียบที่เกี่ยวข้อง
            </h3>
        </div>
        <div class="row">
            <div class="col-12 grid-margin">
                <div class="card" style="border-radius: 15px;">

                    <div class="card-body" style="min-height: 70vh;">
                        <div class="row">
                            <div class="col-3">
                                <ul class="nav nav-pills nav-pills-vertical nav-pills-primary" id="v-pills-tab"
                                    role="tablist" aria-orientation="vertical">
                                    <li class="nav-item" (click)="displayPdf = false">
                                        <a class="nav-link active" id="v-pills-act-tab" data-toggle="pill"
                                            href="#v-pills-act" role="tab" aria-selected="true">
                                            <i class="mdi mdi-bookmark-outline"></i> พระราชบัญญัติ และกฎกระทรวง </a>
                                    </li>
                                    <li class="nav-item" (click)="displayPdf = false">
                                        <a class="nav-link" id="v-pills-law-tab" data-toggle="pill" href="#v-pills-law"
                                            role="tab" aria-selected="false">
                                            <i class="mdi mdi-bookmark-outline"></i> กฎหมาย ระเบียบ ข้อบังคับอื่นๆ
                                            ที่เกี่ยวข้อง </a>
                                    </li>
                                    <li class="nav-item" (click)="displayPdf = false">
                                        <a class="nav-link" id="v-pills-announce-tab" data-toggle="pill"
                                            href="#v-pills-announce" role="tab" aria-selected="false">
                                            <i class="mdi mdi-bookmark-outline"></i> ประกาศ คำสั่งคณะกรรมการ </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-9">
                                <div class="tab-content tab-content-vertical" id="v-pills-tabContent">
                                    <div class="tab-pane fade show active" id="v-pills-act" role="tabpanel"
                                        style="min-height: 60vh;">
                                        <div *ngIf="!displayPdf">
                                            <div class="table-responsive" style="cursor:context-menu;">
                                                <table class="table table-striped">
                                                    <colgroup>
                                                        <col style="width: 5%; text-align: center;">
                                                        <col style="width: 95%;">
                                                    </colgroup>
                                                    <tbody>
                                                        <tr *ngFor="let file of data_act| paginate : {
                                        itemsPerPage: tableSize_act,
                                        currentPage: page_act,
                                        totalItems: count_act
                                      };" style="cursor: pointer;">
                                                            <td><i class="mdi mdi-file-document"></i></td>
                                                            <td>{{file.pdf_name}}</td>
                                                            <td><button type="button"
                                                                    class="btn btn-inverse-danger btn-icon btn-sm"
                                                                    (click)="onClickView(file.pdf_file, file.pdf_name)">
                                                                    <i class="mdi mdi-eye"></i>
                                                                </button>
                                                                <button type="button"
                                                                    class="btn btn-inverse-primary btn-icon btn-sm"
                                                                    style="margin-left: 10px;"
                                                                    (click)="onClickDownload(file.pdf_file, file.pdf_name)">
                                                                    <i class="mdi mdi-download"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div style="position: absolute; left: 0; bottom: 0; width: 100%;">
                                                <pagination-controls *ngIf="data_act.length!=0" class="my-pagination"
                                                    previousLabel="ก่อนหน้า" nextLabel="ถัดไป"
                                                    (pageChange)="onTableAct($event)" style="text-align: center;">
                                                </pagination-controls>
                                            </div>
                                        </div>
                                        <div *ngIf="displayPdf">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-9 text-left" style="cursor:context-menu;">
                                                        {{pdfName}}</div>
                                                    <div class="col-3 text-right"><button type="button"
                                                            class="btn btn-outline-primary"
                                                            (click)="onClickClose()">ย้อนกลับ</button></div>
                                                </div>
                                                <pdf-viewer [original-size]="false" [src]="pdfView" [render-text]="true"
                                                    style="display: block;"></pdf-viewer>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="v-pills-law" role="tabpanel"
                                        style="min-height: 60vh;">
                                        <div *ngIf="!displayPdf">
                                            <div class="table-responsive" style="cursor:context-menu;">
                                                <table class="table table-striped">
                                                    <colgroup>
                                                        <col style="width: 5%; text-align: center;">
                                                        <col style="width: 95%;">
                                                    </colgroup>
                                                    <tbody>
                                                        <tr *ngFor="let file of data_law| paginate : {
                                        itemsPerPage: tableSize_law,
                                        currentPage: page_law,
                                        totalItems: count_law
                                      };" style="cursor: pointer;">
                                                            <td><i class="mdi mdi-file-document"></i></td>
                                                            <td>{{file.pdf_name}}</td>
                                                            <td><button type="button"
                                                                    class="btn btn-inverse-danger btn-icon btn-sm"
                                                                    (click)="onClickView(file.pdf_file, file.pdf_name)">
                                                                    <i class="mdi mdi-eye"></i>
                                                                </button>
                                                                <button type="button"
                                                                    class="btn btn-inverse-primary btn-icon btn-sm"
                                                                    style="margin-left: 10px;"
                                                                    (click)="onClickDownload(file.pdf_file, file.pdf_name)">
                                                                    <i class="mdi mdi-download"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div style="position: absolute; left: 0; bottom: 0; width: 100%;">
                                                <pagination-controls class="my-pagination" previousLabel="ก่อนหน้า"
                                                    *ngIf="data_law.length!=0" nextLabel="ถัดไป"
                                                    (pageChange)="onTableLaw($event)" style="text-align: center;">
                                                </pagination-controls>
                                            </div>
                                        </div>
                                        <div *ngIf="displayPdf">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-9 text-left" style="cursor:context-menu;">
                                                        {{pdfName}}</div>
                                                    <div class="col-3 text-right"><button type="button"
                                                            class="btn btn-outline-primary"
                                                            (click)="onClickClose()">ย้อนกลับ</button></div>
                                                </div>
                                                <pdf-viewer [original-size]="false" [src]="pdfView" [render-text]="true"
                                                    style="display: block;"></pdf-viewer>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="v-pills-announce" role="tabpanel"
                                        style="min-height: 60vh;">
                                        <div *ngIf="!displayPdf">
                                            <div class="table-responsive" style="cursor:context-menu;">
                                                <table class="table table-striped">
                                                    <colgroup>
                                                        <col style="width: 5%; text-align: center;">
                                                        <col style="width: 95%;">
                                                    </colgroup>
                                                    <tbody>
                                                        <tr *ngFor="let file of data_announce| paginate : {
                                        itemsPerPage: tableSize_ann,
                                        currentPage: page_ann,
                                        totalItems: count_ann
                                      };" style="cursor: pointer;">
                                                            <td><i class="mdi mdi-file-document"></i></td>
                                                            <td>{{file.pdf_name}}</td>
                                                            <td><button type="button"
                                                                    class="btn btn-inverse-danger btn-icon btn-sm"
                                                                    (click)="onClickView(file.pdf_file, file.pdf_name)">
                                                                    <i class="mdi mdi-eye"></i>
                                                                </button>
                                                                <button type="button"
                                                                    class="btn btn-inverse-primary btn-icon btn-sm"
                                                                    style="margin-left: 10px;"
                                                                    (click)="onClickDownload(file.pdf_file, file.pdf_name)">
                                                                    <i class="mdi mdi-download"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div style="position: absolute; left: 0; bottom: 0; width: 100%;">
                                                <pagination-controls class="my-pagination" previousLabel="ก่อนหน้า"
                                                    *ngIf="data_announce.length!=0" nextLabel="ถัดไป"
                                                    (pageChange)="onTableAnn($event)" style="text-align: center;">
                                                </pagination-controls>
                                            </div>
                                        </div>
                                        <div *ngIf="displayPdf">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-9 text-left" style="cursor:context-menu;">
                                                        {{pdfName}}</div>
                                                    <div class="col-3 text-right"><button type="button"
                                                            class="btn btn-outline-primary"
                                                            (click)="onClickClose()">ย้อนกลับ</button></div>
                                                </div>
                                                <pdf-viewer [original-size]="false" [src]="pdfView" [render-text]="true"
                                                    style="display: block;"></pdf-viewer>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
    <footer class="footer" style="padding-top: 10px; padding-bottom: 10px;">
        <div class="d-sm-flex justify-content-center justify-content-sm-between">
            <span class="text-muted text-center text-sm-left d-block d-sm-inline-block"
                style="margin-top: auto; margin-bottom: 0px;">Copyright © 2023 <a href="https://www.mapedia.co.th/"
                    target="_blank">MAPEDIA . co . th</a>. All rights
                reserved.</span>
            <div class="text-right">
                <div class="text-right" style="margin-right: 3px;">จำนวนผู้เข้าชมเว็บไซต์</div>
                <div class="text-right">
                    <span class="count-visitor" *ngFor="let i of visitor">{{i}}</span>
                </div>
            </div>
        </div>
    </footer> -->